import React from 'react'
import { Header } from '../Core/Header'
import { Footer } from '../Core/Footer'

const WishList = () => {
  return (
    <div>
        <Header/>

    <div className="enquiry-wrapper flex gap-2">
        
    </div>
        <Footer/>
    </div>
  )
}

export default WishList